/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import { locales } from "../../locales";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const PartySelect = ({
  data,
  partyQueryHandler,
  isDesktop,
  isCommuneSearchActive,
  langId,
}) => {
  const [selected, setSelected] = useState(data[0]);

  useEffect(() => {
    partyQueryHandler(selected);
  }, [selected]);

  useEffect(() => {
    if (!isCommuneSearchActive) {
      setSelected(data[0]);
    }
  }, [isCommuneSearchActive]);

  const inputWidth = (isDesktop) => {
    if (isDesktop) {
      return { width: "546px" };
    } else {
      return { width: "100%" };
    }
  };

  return (
    <div
      className={`${isDesktop ? "ml-4" : "ml-0"}`}
      style={inputWidth(isDesktop)}
    >
      {isCommuneSearchActive ? (
        <input
          type="text"
          className="cursor-not-allowed w-full h-12 py-2 pl-3 pr-10 text-left text-gray-700 bg-gray-100 bg-clip-padding rounded-md border border-gray-300"
          placeholder={locales[langId].all}
          aria-label={locales[langId].all}
          disabled
        />
      ) : (
        <Listbox value={selected} onChange={setSelected}>
          {({ open }) => (
            <>
              <div className="relative">
                <Listbox.Button className="relative w-full cursor-default h-12 rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-focus-ring focus:outline-none focus:ring-1 focus:ring-focus-ring sm:text-sm">
                  <span className="block truncate">{selected}</span>
                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                    <ChevronDownIcon
                      className="h-5 w-5 text-black"
                      aria-hidden="true"
                    />
                  </span>
                </Listbox.Button>

                <Transition
                  show={open}
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Listbox.Options className="absolute z-10 mt-1 max-h-80 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                    {data
                      .filter((item) => item !== "Zesumme fir Leideleng")
                      .map((party) => (
                        <Listbox.Option
                          key={party}
                          className={({ active }) =>
                            classNames(
                              active
                                ? "text-gray-900 bg-F4F4F4"
                                : "text-gray-900",
                              "relative cursor-default select-none py-1 pl-8 pr-4"
                            )
                          }
                          value={party}
                        >
                          {({ selected, active }) => (
                            <>
                              <span
                                className={classNames(
                                  selected ? "font-semibold" : "font-normal",
                                  "block truncate"
                                )}
                              >
                                {party}
                              </span>

                              {selected ? (
                                <span
                                  className={classNames(
                                    active
                                      ? "text-focus-ring"
                                      : "text-focus-ring",
                                    "absolute inset-y-0 left-0 flex items-center pl-1.5"
                                  )}
                                >
                                  <CheckIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                  />
                                </span>
                              ) : null}
                            </>
                          )}
                        </Listbox.Option>
                      ))}
                  </Listbox.Options>
                </Transition>
              </div>
            </>
          )}
        </Listbox>
      )}
    </div>
  );
};

export default PartySelect;
